import { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { LoginSocialGoogle } from './LoginSocialGoogle';
import { LoginSocialMicrosoft } from './LoginSocialMicrosoft';
import { resetJustSignedOut, socialSignIn } from 'reducers/userReducer';
import {
	GoogleLoginButton,
	MicrosoftLoginButton,
} from 'react-social-login-buttons';
import './SocialLogin.css';

const REDIRECT_URI = window.location.origin + '/sign-in';

/**
 * Social Logins Component
 *
 * Uses reactjs-social-login for reliable OAuth handling
 */
export const SocialLogins = memo((props) => {
	const { title = 'Continue' } = props;
	const [currentProvider, setProvider] = useState('');
	const [error, setError] = useState('');
	const dispatch = useDispatch();
	const history = useHistory();

	/**
	 * Handle successful OAuth login
	 *
	 * @param {string} provider - 'google' or 'microsoft'
	 * @param {Object} data - OAuth data (token or code)
	 */

	const onSuccess = (provider, data) => {
		dispatch(resetJustSignedOut());
		setProvider(provider);
		return dispatch(
			socialSignIn({ ...data, redirect_uri: REDIRECT_URI }, provider),
		).then((res) => {
			if (res?.payload?.userData?.id) {
				//sign in success
				history.push('/dashboard/overview');
			}
		});
	};

	/**
	 * Handle OAuth error
	 */
	const onReject = (err) => {
		console.error('OAuth rejected:', err);
		setError('Authentication cancelled or failed');
		setProvider('');
	};

	return (
		<div className="social-login-container">
			{error && (
				<div className="social-login-error">
					<span className="error-icon">⚠️</span>
					{error}
				</div>
			)}

			<div className="social-login-divider">
				<span>or continue with</span>
			</div>

			{/* Google Login */}
			<div className="social-login-button-wrapper">
				<LoginSocialGoogle
					client_id="1062158216797-i9m6p08170a13ftiop9mirj7tlo5nulg.apps.googleusercontent.com"
					redirect_uri={REDIRECT_URI}
					scope="openid profile email"
					onResolve={({ provider, data }) => {
						onSuccess('google', data);
					}}
					onReject={onReject}
					isDisabled={currentProvider === 'google'}
					isOnlyGetCode
					isOnlyGetToken={false}
					access_type="offline"
				>
					<GoogleLoginButton
						className="btn-social-login"
						align="center"
						text={`${title} with Google`}
						disabled={!!currentProvider}
					/>
				</LoginSocialGoogle>
			</div>

			{/* Microsoft Login */}
			<div className="social-login-button-wrapper">
				<LoginSocialMicrosoft
					client_id="adf83a87-c8e2-4f3a-9bbe-a20cf7ca9d1b"
					redirect_uri={REDIRECT_URI}
					onResolve={({ provider, data }) => {
						onSuccess('microsoft', data);
					}}
					onReject={onReject}
					isDisabled={currentProvider === 'microsoft'}
					isOnlyGetCode
					isOnlyGetToken={false}
					access_type="offline"
				>
					<MicrosoftLoginButton
						className="btn-social-login"
						align="center"
						text={`${title} with Microsoft`}
						disabled={!!currentProvider}
					/>
				</LoginSocialMicrosoft>
			</div>
		</div>
	);
});
